export default __webpack_public_path__ + "static/media/01AW1AUG66.4beae70f.jpg";